"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureManager = void 0;
var index_1 = require("../index");
function isEnabled(featureName, features) {
    var _a;
    if (!features || Object.keys(features).length === 0)
        return false;
    return ((_a = features[featureName]) === null || _a === void 0 ? void 0 : _a.enabled) || false;
}
var featureManager = function (features) { return ({
    isEnabled: isEnabled,
    isKillSwitchEnabled: function () {
        return isEnabled(index_1.UNLEASH_FEATURE_NAMES.killSwitch, features);
    },
    isServerAfsDivEnabled: function () {
        return isEnabled(index_1.UNLEASH_FEATURE_NAMES.enableServerAfsDiv, features);
    },
    isMockApiEnabled: function () { return isEnabled(index_1.UNLEASH_FEATURE_NAMES.mockApi, features); },
    isXandrFallbackVersionEnabled: function () {
        return isEnabled(index_1.UNLEASH_FEATURE_NAMES.xandrFallbackVersion, features);
    },
    forceUnleashTestMemberId: function () {
        return isEnabled(index_1.UNLEASH_FEATURE_NAMES.forceUnleashTestMemberId, features);
    },
    isDisableRelevantDigitalEnabled: function () {
        return isEnabled(index_1.UNLEASH_FEATURE_NAMES.disableRelevantDigital, features);
    },
    isIframeHeightOnBannersEnabled: function () {
        return isEnabled(index_1.UNLEASH_FEATURE_NAMES.iframeHeightOnBanners, features);
    },
    isDisableSafeFrameEnabled: function () {
        return isEnabled(index_1.UNLEASH_FEATURE_NAMES.disableSafeFrame, features);
    },
    isAfsEnabled: function () {
        return isEnabled(index_1.UNLEASH_FEATURE_NAMES.enableAfsPlacements, features);
    }
}); };
exports.featureManager = featureManager;
